import React, { Component, Fragment } from 'react';
import ScrollLock from 'react-scrolllock';

import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';
import Button from '../../artzu-ui/src/Button';
class BookingComponent extends Component {
  render() {
    const { id, history, status, email, operatingCity } = this.props;
    return (
      <div className="intro container new-course">
        {/introapp/.test(window.location.href) ? null : (
          <Header
            persistentTitle
            title="Booking"
            back
            onClick={() => {
              history.goBack();
            }}
          />
        )}
        <div className="new-course__body__footer--mobile">
          <div className="new-course__body__buttons">
            {/introapp/.test(window.location.href) ? (
              <a href={`/introapp/${Number(id) - 1}`}>
                <Button
                  color="#414141"
                  label="Previous"
                  size="xl"
                  padding="0"
                />
              </a>
            ) : (
              <Button
                color="#414141"
                label="Previous"
                size="xl"
                padding="0"
                onClick={() => history.push(`/intro/${Number(id) - 1}`)}
              />
            )}
            {/introapp/.test(window.location.href) ? (
              <a href={`/introapp/${Number(id) + 1}`}>
                <Button primary label="Next" size="xl" padding="0" />
              </a>
            ) : (
              <Button
                primary
                label="Next"
                size="xl"
                padding="0"
                onClick={() => history.push(`/intro/${Number(id) + 1}`)}
              />
            )}
          </div>
        </div>
        <ScrollLock>
          <div className="intro__content new-course__container">
            <div className="intro__sidebar new-course__sidebar">
              <SideBarContent status={status} signedIn={email} />
            </div>
            <div
              className="new-course__body"
              style={
                /introapp/.test(window.location.href)
                  ? { marginTop: '0' }
                  : null
              }>
              <div className="intro__content--container">
                <div className="intro__content__title">
                  Plan Your Bookings
                </div>
                <div className="intro__content__para">
                  Log in to autzu.com to access your Dashboard. This is
                  where you will see your current and future bookings.
                </div>
                <div className="intro__content__para">
                  You can book for 4, 8, or 12 hours each day. If there is
                  still availability toward the end time of your booking,
                  you will get a text message asking if you’d like to
                  extend by adding 4 more hours.
                </div>
                <br />
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__title">Autzu PRO</div>
                )}
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__para">
                    Now that your Autzu account is active, you can book a
                    PRO car.
                  </div>
                )}

                <br />
                <div className="intro__content__title">
                  Dynamic Pricing
                </div>
                <div className="intro__content__para">
                  Price is determined by availability of cars. The earlier
                  you book, the better the chance to get the lowest price.
                  You can check price and availability by going to
                  “Pricing” in the menu.
                </div>
                {operatingCity === 'new_york' ? null : (
                  <div className="intro__content__para">
                    The price of PRO starts at $6/hr plus tax.
                    <br />
                    <br />
                    <br />
                  </div>
                )}
              </div>
              <div className="new-course__body__footer--desktop intro__content__footer--desktop">
                <div className="new-course__body__buttons intro__content__footer--buttons">
                  <Button
                    color="#414141"
                    label="Previous"
                    size="xl"
                    onClick={() =>
                      history.push(`/intro/${Number(id) - 1}`)
                    }
                  />
                  <Button
                    primary
                    label="Next"
                    size="xl"
                    onClick={() =>
                      history.push(`/intro/${Number(id) + 1}`)
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </ScrollLock>
      </div>
    );
  }
}

export default BookingComponent;



// WEBPACK FOOTER //
// ./src/components/Intro/BookingComponent.js